import { css, DefaultTheme } from 'styled-components';
import { getResponsiveTypography, hexToRgba } from '../helpers/styleHelpers';

export const minBp = (breakpoint: number) => `@media (min-width: ${breakpoint}px)`;

export const maxBp = (breakpoint: number) => `@media (max-width: ${breakpoint}px)`;

export const minMaxBp = (min: number, max: number) =>
  `@media (min-width: ${min}px) and (max-width: ${max}px)`;

export const getAllResponsiveTypography = (
  theme: DefaultTheme,
  elementType: string,
  width: number,
) => `
    font-family: ${getResponsiveTypography(theme, 'fontFace', elementType, width)};
    font-size: ${getResponsiveTypography(theme, 'fontSize', elementType, width)};
    line-height: ${getResponsiveTypography(theme, 'lineHeight', elementType, width)};
    font-weight: ${getResponsiveTypography(theme, 'fontWeight', elementType, width)};
    letter-spacing: ${getResponsiveTypography(theme, 'letterSpacing', elementType, width)};
  `;

export const h1Styles = css`
  ${({ theme }: { theme: DefaultTheme }) => `
    ${getAllResponsiveTypography(theme, 'h1', theme.breakpoints.aa)}  
    text-transform: ${theme.typography.transform.h1};

    ${minBp(theme.breakpoints.a)} {
      ${getAllResponsiveTypography(theme, 'h1', theme.breakpoints.a)}  
    }

    ${minBp(theme.breakpoints.ba)} {
      ${getAllResponsiveTypography(theme, 'h1', theme.breakpoints.ba)}  
    }
  `}
`;

export const h2Styles = css`
  ${({ theme }: { theme: DefaultTheme }) => `
    ${getAllResponsiveTypography(theme, 'h2', theme.breakpoints.aa)}  
    text-transform: ${theme.typography.transform.h1};

    ${minBp(theme.breakpoints.a)} {
      ${getAllResponsiveTypography(theme, 'h2', theme.breakpoints.a)}  
    }

    ${minBp(theme.breakpoints.ba)} {
      ${getAllResponsiveTypography(theme, 'h2', theme.breakpoints.ba)}  
    }
  `}
`;

export const h3Styles = css`
  ${({ theme }: { theme: DefaultTheme }) => `
    ${getAllResponsiveTypography(theme, 'h3', theme.breakpoints.aa)}  
    text-transform: ${theme.typography.transform.h1};

    ${minBp(theme.breakpoints.a)} {
      ${getAllResponsiveTypography(theme, 'h3', theme.breakpoints.a)}  
    }

    ${minBp(theme.breakpoints.ba)} {
      ${getAllResponsiveTypography(theme, 'h3', theme.breakpoints.ba)}  
    }
  `}
`;

export const h4Styles = css`
  ${({ theme }: { theme: DefaultTheme }) => `
    ${getAllResponsiveTypography(theme, 'h4', theme.breakpoints.aa)}  
    text-transform: ${theme.typography.transform.h1};

    ${minBp(theme.breakpoints.a)} {
      ${getAllResponsiveTypography(theme, 'h4', theme.breakpoints.a)}  
    }

    ${minBp(theme.breakpoints.ba)} {
      ${getAllResponsiveTypography(theme, 'h4', theme.breakpoints.ba)}  
    }
  `}
`;

export const h5Styles = css`
  ${({ theme }: { theme: DefaultTheme }) => `
    ${getAllResponsiveTypography(theme, 'h5', theme.breakpoints.aa)}  
    text-transform: ${theme.typography.transform.h1};
    ${minBp(theme.breakpoints.a)} {
      ${getAllResponsiveTypography(theme, 'h5', theme.breakpoints.a)}
    }

    ${minBp(theme.breakpoints.ba)} {
      ${getAllResponsiveTypography(theme, 'h5', theme.breakpoints.ba)}
    }
  `}
`;

export const h6Styles = css`
  ${({ theme }: { theme: DefaultTheme }) => `
    ${getAllResponsiveTypography(theme, 'h6', theme.breakpoints.aa)}
    text-transform: ${theme.typography.transform.h1};
    ${minBp(theme.breakpoints.a)} {
      ${getAllResponsiveTypography(theme, 'h6', theme.breakpoints.a)}
    }

    ${minBp(theme.breakpoints.ba)} {
      ${getAllResponsiveTypography(theme, 'h6', theme.breakpoints.ba)}
    }
  `}
`;

export const body = css`
  ${({ theme }: { theme: DefaultTheme }) => `
    ${getAllResponsiveTypography(theme, 'body', theme.breakpoints.aa)}
    ${minBp(theme.breakpoints.a)} {
      ${getAllResponsiveTypography(theme, 'body', theme.breakpoints.a)}
    }

    ${minBp(theme.breakpoints.ba)} {
      ${getAllResponsiveTypography(theme, 'body', theme.breakpoints.ba)}
    }
  `}
`;

export const bodySmall = css`
  ${({ theme }: { theme: DefaultTheme }) => `
    ${getAllResponsiveTypography(theme, 'bodySmall', theme.breakpoints.aa)}
    ${minBp(theme.breakpoints.a)} {
      ${getAllResponsiveTypography(theme, 'bodySmall', theme.breakpoints.a)}
    }

    ${minBp(theme.breakpoints.ba)} {
      ${getAllResponsiveTypography(theme, 'bodySmall', theme.breakpoints.ba)}
    }
  `}
`;

export const bodyLarge = css`
  ${({ theme }: { theme: DefaultTheme }) => `
    ${getAllResponsiveTypography(theme, 'bodyLarge', theme.breakpoints.aa)}
    ${minBp(theme.breakpoints.a)} {
      ${getAllResponsiveTypography(theme, 'bodyLarge', theme.breakpoints.a)}
    }

    ${minBp(theme.breakpoints.ba)} {
      ${getAllResponsiveTypography(theme, 'bodyLarge', theme.breakpoints.ba)}
    }
  `}
`;

export const blockquote = css`
  ${({ theme }: { theme: DefaultTheme }) => `
    ${getAllResponsiveTypography(theme, 'blockquote', theme.breakpoints.aa)}
    ${minBp(theme.breakpoints.a)} {
      ${getAllResponsiveTypography(theme, 'blockquote', theme.breakpoints.a)}
    }

    ${minBp(theme.breakpoints.ba)} {
      ${getAllResponsiveTypography(theme, 'blockquote', theme.breakpoints.ba)}
    }
    
    strong {
      ${getAllResponsiveTypography(theme, 'blockquoteBold', theme.breakpoints.aa)}
      ${minBp(theme.breakpoints.a)} {
        ${getAllResponsiveTypography(theme, 'blockquoteBold', theme.breakpoints.a)}
      }

      ${minBp(theme.breakpoints.ba)} {
        ${getAllResponsiveTypography(theme, 'blockquoteBold', theme.breakpoints.ba)}
      }
    }
  `}
`;

export const functional = css`
  ${({ theme }: { theme: DefaultTheme }) => `
    ${getAllResponsiveTypography(theme, 'functional', theme.breakpoints.aa)}
    text-transform: ${theme.typography.transform.functional};
    ${minBp(theme.breakpoints.a)} {
      ${getAllResponsiveTypography(theme, 'functional', theme.breakpoints.a)}
    }

    ${minBp(theme.breakpoints.ba)} {
      ${getAllResponsiveTypography(theme, 'functional', theme.breakpoints.ba)}
    }
  `}
`;

export const gridWidth = css`
  ${({ theme, ...props }: any) => {
    const noPadding = props.noPadding || props.$noPadding;
    return `
    max-width: ${theme.style.page.maxWidth};
    margin: 0 auto;

    ${
      !noPadding
        ? `
      padding-left: 5%;
      padding-right: 5%;

      @media (min-width: 480px) {
        padding-left: 3%;
        padding-right: 3%;
      }
      `
        : ''
    }
  `;
  }}
`;

export const columnMixin = (col: number, sum: number, deskPad = 10, mobPad = 4) => `
  width: ${(col / sum) * 100}%;
  display: inline-block;
  box-sizing: border-box;
  padding: 0 ${mobPad}%;
  ${
    deskPad
      ? `@media (min-width: 480px) {
      padding: 0 ${deskPad}%;
    }`
      : ``
  }
`;

const padding: Record<'mobile' | 'desktop', number> = {
  mobile: 10,
  desktop: 4,
};

const grid: Record<'mobile' | 'desktop', number> = {
  mobile: 2,
  desktop: 12,
};

const widthCalc = (col = 1, blocks = 1, device: 'mobile' | 'desktop' = 'desktop') => {
  const columnWidth = (col / grid[device]) * 100;
  const paddingCalc = () => ((blocks - 1) * padding[device]) / blocks;

  if (blocks > 1) {
    const value = columnWidth - paddingCalc();
    return Number.isInteger(value) ? value : value.toFixed(2);
  }

  return Number.isInteger(columnWidth) ? columnWidth : columnWidth.toFixed(2);
};

export interface BetterColumnMixinProps {
  col: number;
  blocks?: number;
  device?: 'mobile' | 'desktop';
  display?: string;
}

export const betterColumnMixin = ({
  col,
  blocks = 1,
  device = 'desktop',
  display,
}: BetterColumnMixinProps) => `
  width: ${widthCalc(col, blocks, device)}%;
  display: ${display || 'inline-block'};
  box-sizing: border-box;
`;

export const cardWidth = {
  quarter: betterColumnMixin({ col: 3, blocks: 4, display: 'flex' }),
  third: betterColumnMixin({ col: 4, blocks: 3, display: 'flex' }),
  half: betterColumnMixin({ col: 6, blocks: 2, display: 'flex' }),
  full: betterColumnMixin({ col: 6, blocks: 1, display: 'flex' }),
};

export const listUnstyled = css`
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    padding-left: 0;

    &::before {
      content: none;
    }
  }

  ul {
    padding-left: 0;
  }
`;

export const resetButton = css`
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  line-height: normal;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  appearance: none;

  &::-moz-focus-inner {
    border: 0;
    padding: 0;
  }
`;

export const AccessibilityHidden = css`
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;

export const textFade = ({ colours }: { colours: any }) => `
      &::before {
      background: linear-gradient(rgba(255, 255, 255, 0) 0%, ${hexToRgba(colours.background.a, 0.8)} 100%);
      bottom: 0;
      content: '';
      height: 50px;
      left: 0;
      position: absolute;
      width: 100%;
    }
`;
// tsc --noEmit && tsc --noEmit -p tsconfig.server.json && tsc --noEmit -p tsconfig.node.json
